import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './RichTextContainer.module.scss';

interface RichTextContainerProps {
  classNames?: string | string[];
  children: ReactNode;
}

const RichTextContainer = ({
  classNames,
  children,
}: RichTextContainerProps) => (
  <div className={cn(styles.richTextContainer, classNames)}>{children}</div>
);

export default RichTextContainer;
